module.exports = __webpack_public_path__ + "static/media/icon-padlock.74041d8c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icon-padlock.svg
// module id = 2569
// module chunks = 0